import type { FaireProductEntity } from "../../entity_types/product";

export const p_h2mjjtdke4: FaireProductEntity = {
  token: "p_h2mjjtdke4",
  type: "product",
  name: "Gummy Pineapple Rings",
  brandName: "Hawaiian Sweets",
  imageUrl:
    "https://cdn.faire.com/fastly/15191e955b97c57baaf42834d9392dde5acdf64d5d14d21008ea547c16648255.jpeg",
  priceDollars: 2.89,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c665126c08e065f795a95eeaa5c538ef7ae31bd46bff34bce1b7ecda4131f082.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
